module.exports = __webpack_public_path__ + "static/media/cf.037865b5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cf.svg
// module id = 882
// module chunks = 0